import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  isLogin:any;
  token:any;
  constructor(
   
    private router: Router,private toastr: ToastrService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.isLogin=localStorage.getItem('userid');
      this.token=localStorage.getItem('token')
      if(this.isLogin && this.token ){
        return true;
      }else{
        
        this.router.navigate(['/']);
        this.toastr.warning('Register/Login to continue')
        return false;
      }
  
  }
  
}
